import {
  usePlaybackIsPlaying,
  usePlaybackIsSeeking,
  usePlaybackPause,
} from '@app/core/playback/hooks/usePlayback';
import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';
import { useAddChunkFromSelection } from '../../../../fragment-editor/hooks/useAddChunkFromSelection';
import { usePlaySelection } from '../../../../hooks/playback/useStreamPlayback';
import { SelectionMenuEditorP } from './SelectionMenuEditorP';

export function SelectionMenuEditor() {
  const isSeeking = usePlaybackIsSeeking();
  const isPlaying = usePlaybackIsPlaying();
  const pause = usePlaybackPause();
  const playSelection = usePlaySelection();
  const { clearSelection } = useStreamSelection();

  const { addChunkFromSelection, canAddChunk } = useAddChunkFromSelection();

  return (
    <SelectionMenuEditorP
      loadingAudio={isSeeking}
      play={isPlaying ? null : () => playSelection()}
      pause={isPlaying ? () => pause() : null}
      addChunk={canAddChunk ? addChunkFromSelection : null}
      clear={clearSelection}
    />
  );
}
